class PubSub {
  constructor() {
    this.events = {} // {`event`: [subscriber, ...], ...}
    // subscriber is function(...data) or object with method receive(...data)
  }
  
  publish(event, ...data) {
    if (this.events[event] !== undefined) {
      for (var i = 0, len = this.events[event].length; i < len; i++) {
        let subscriber = this.events[event][i], handler = null;
        
        if (typeof subscriber == 'function')
          handler = subscriber;
        else if (typeof subscriber.receive == 'function')
          handler = subscriber.receive;
        
        if (handler)
          handler.call(subscriber, ...data);
        else
          console.debug('incorrect subscriber: ' + (typeof subscriber), subscriber);
      }
    } else {
      console.debug('message not caught: ' + event);
    }
  }
  
  subscribe(event, subscriber) {
    if (this.events[event] === undefined)
      this.events[event] = [];
    this.events[event].push(subscriber);
    return this;
  }
  
  unsubscribe(event, subscriber) {
    if (this.events[event] === undefined) {
      console.warn("No subscribers found for", event);
      return false;
    }

    let index = this.events[event].indexOf(subscriber);

    if (index >= 0) {
      this.events[event].splice(index, 1); // remove element and reindex array
      return true;
    }
    
    console.warn("Subscriber is not found", subscriber);
    return false;
  }
}

export let pubsub = new PubSub();



// WEBPACK FOOTER //
// ./app/javascript/components/pubsub.js